import styled from 'styled-components';

export const ModalHeaderBlock = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px 16px;
    text-align: left;
`;

export const TitleRow = styled.div`
    width: fit-content;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
`;

export const HeaderButtonRow = styled.div`
    width: auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;

export const Form = styled.form`
    padding: 0 24px 24px;
    text-align: left;
`;

export const FormGrid = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const Row = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 16px;

    & > * {
        flex: 1;
        min-width: 140px;
    }
`;

export const ButtonRow = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 8px;
    padding-top: 16px;
`;

export const ActionsRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 12px;
    padding-top: 12px;
`;
